export default __webpack_public_path__ + "static/media/defi.36bcb748.jpeg";